import { render } from "./TheDialog.vue?vue&type=template&id=227b4bca&scoped=true"
import script from "./TheDialog.vue?vue&type=script&lang=js"
export * from "./TheDialog.vue?vue&type=script&lang=js"

import "./TheDialog.vue?vue&type=style&index=0&id=227b4bca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227b4bca"]])

export default __exports__